package com.bikompanion.data

import de.jensklingenberg.ktorfit.http.GET
import de.jensklingenberg.ktorfit.http.Path
import de.jensklingenberg.ktorfit.http.Query
import kotlinx.serialization.json.Json

interface CityBikesApi {
    @GET("networks")
    suspend fun getNetworks(): CityBikesNetworksResponse

    @GET("networks/{id}")
    suspend fun getNetworkDetail(
        @Path("id") id: String,
        @Query("fields") fields: String = "stations",
    ): CityBikesNetworkDetailResponse
}

/**
 * One lenient JSON reader for every bike feed.
 *
 * Both sources publish far more per station than the map draws, and GBFS keeps adding fields
 * with each minor version, so unknown keys have to be skipped rather than fatal.
 */
internal val apiJson = Json { ignoreUnknownKeys = true }
